import { render, staticRenderFns } from "./ProjectEnglishName.vue?vue&type=template&id=7652960c&scoped=true&"
import script from "./ProjectEnglishName.vue?vue&type=script&lang=js&"
export * from "./ProjectEnglishName.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEnglishName.vue?vue&type=style&index=0&id=7652960c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7652960c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
installComponents(component, {VForm})
